import { all, put, takeEvery } from 'redux-saga/effects';
import URLs from '../../../constants/urls';
import { apiPython as api } from '../../../service/api';
import {
  getUserListSuccessAction,
  getUserListFailureAction,
  getCycleListSuccessAction,
  getCycleListFailureAction,
  getUserAnalysisSuccessAction,
  getUserAnalysisFailureAction,
  getCurrentCycleStatusSuccessAction,
  getCurrentCycleStatusFailureAction,
  getAssessorFeedbackSuccessAction,
  getAssessorFeedbackFailureAction,
  getAssessorFeedbackAction,
  getUserProficiencyLevelFailureAction,
  getUserProficiencyLevelSuccessAction,
  getScoreDetailsSuccessAction,
  getScoreDetailsFailureAction,
  getCurrentResponseDataSuccessAction,
  getCurrentResponseDataFailureAction,
  saveResponseSuccessAction,
  saveResponseFailureAction,
  deleteAttachmentSuccessAction,
  deleteAttachmentFailureAction,
  downloadAttachmentFailureAction,
  downloadAttachmentSuccessAction,
  resetExamSuccessAction,
  resetExamFailureAction,
  getSelfCycleListSuccessAction,
  getSelfCycleListFailureAction,
  getTakeSelfAssessmentSuccessAction,
  getTakeSelfAssessmentFailureAction,
  getEvaluationCycleListSuccessAction,
  getEvaluationCycleListFailureAction,
  getEvaluateScoreDetailsSuccessAction,
  getEvaluateScoreDetailsFailureAction
} from '../../features/userAnalysis/userAnalysisSlice';
import { normalizeTakeAssessmentPayload } from '../../../utils/apiPayload';
import {
  GET_USERLIST,
  GET_CYCLE,
  GET_USER_ANALYSIS,
  GET_CURRENT_CYCLE_STATUS,
  GET_ASSESSOR_FEEDBACK,
  GET_USER_PROFICIENCYLEVEL,
  GET_SCORE_DETAILS,
  GET_CURRENT_RESPONSE_DATA,
  SAVE_RESPONSE,
  DELETE_ATTACHMENT,
  DOWNLOAD_ATTACHMENT,
  RESET_ASSESSMENT,
  GET_SELF_CYCLE,
  TAKE_SELF_ASSESSMENT,
  GET_EVAL_CYCLE,
  GET_EVAL_SCORE_DETAILS
} from '../../actions/userAnalysis/actionTypes';
import { getSessionStorage } from '../../../utils/helpers';

export function* getUserListSaga() {
  try {
    const response = yield api.get(`${URLs.GET_USER_LIST}?status=&userSamId=${getSessionStorage('USER_ID')}`);
    yield put(getUserListSuccessAction(response.data.data));
  } catch (error) {
    yield put(getUserListFailureAction(error?.response?.data?.message ? error?.response?.data?.message : 'Fetch failed'));
  }
}

export function* getCycleListSaga({ payload }) {
  try {
    const order = payload?.orderType || 'Evaluation';
    const response = yield api.get(
      `${URLs.GET_CYCLE_LIST}?isAssessor=${payload.isAssessor}&SAMId=${payload?.userId}&LoginSamID=${getSessionStorage(
        'USER_ID'
      )}&Order=${encodeURIComponent(order)}`
    );
    yield put(getCycleListSuccessAction(response.data.data));
  } catch (error) {
    yield put(getCycleListFailureAction(error?.response?.data ? error?.response?.data : 'Fetch failed'));
  }
}

export function* getEvaluationCycleListSaga({ payload }) {
  try {
    const response =  yield api.get(
      `${URLs.GET_CYCLE_LIST}?isAssessor=${payload.isAssessor}&SAMId=${getSessionStorage('USER_ID')}&LoginSamID=${getSessionStorage('USER_ID')}&Order=Evaluation`)
    yield put(getEvaluationCycleListSuccessAction(response.data.data));
  } catch (error) {
    yield put(getEvaluationCycleListFailureAction(error?.response?.data ? error?.response?.data : 'Fetch failed'));
  }
}

export function* getSelfCycleListSaga({ payload }) {
  try {
    // const response = yield api.get(`${URLs.GET_CYCLE_LIST}?isAssessor=${payload.isAssessor}&SAMId=q754037&LoginSamID=q1059150`); //replace with SDA loginid
    const loginSamId = getSessionStorage('USER_ID') || payload?.userId || '';
    const response = yield api.get(
      `${URLs.GET_SELF_CYCLE}?isAssessor=false&Order=Self&LoginSamID=${encodeURIComponent(loginSamId)}`
    );
    yield put(getSelfCycleListSuccessAction(response.data.data));
  } catch (error) {
    yield put(getSelfCycleListFailureAction(error?.response?.data ? error?.response?.data : 'Fetch failed'));
  }
}


export function* getUserAnalysisSaga({ payload }) {
  try {
    const response = payload.isAssessor
      ? yield api.get(
          `${URLs.GET_USER_ANALYSIS}?id=${payload.id}&isAssessor=${payload.isAssessor}&SAMId=${
            payload.samId
          }&LoginSamID=${getSessionStorage('USER_ID')}`
        )
      : yield api.get(
          `${URLs.GET_USER_ANALYSIS}?id=${payload.id}&isAssessor=${payload.isAssessor}&SAMId=${getSessionStorage(
            'USER_ID'
          )}&LoginSamID=${getSessionStorage('USER_ID')}&SAMId=${getSessionStorage('USER_ID')}` //replace with SDA loginid
        );
    yield put(getUserAnalysisSuccessAction(response.data.data));
  } catch (error) {
    yield put(getUserAnalysisFailureAction(error?.response?.data ? error?.response?.data : 'Fetch failed'));
  }
}

export function* getCurrentCycleStatus({ payload }) {
  try {
    const response = yield api.get(`${URLs.GET_CURRENT_CYCLE_STATUS}?CurrentResponseId=${payload.cId}`); //replace with SDA loginid
    yield put(getCurrentCycleStatusSuccessAction(response.data.data));
  } catch (error) {
    yield put(getCurrentCycleStatusFailureAction(error?.response?.data ? error?.response?.data : 'Fetch failed'));
  }
}

export function* getAssessorFeedback({ payload }) {
  try {
    const response = yield api.get(`${URLs.GET_ASSESSOR_FEEDBACK}?CurrentResponseId=${payload.crId}`); //replace with SDA loginid
    yield put(getAssessorFeedbackSuccessAction(response.data.data));
  } catch (error) {
    yield put(getAssessorFeedbackFailureAction(error?.response?.data ? error?.response?.data : 'Fetch failed'));
  }
}

export function* getUserProficiencyLevel({ payload }) {
  try {
    const response = yield api.get(`${URLs.GET_USER_PROFICIENCYLEVEL}?score=${payload}`); //replace with SDA loginid
    yield put(getUserProficiencyLevelSuccessAction(response.data.data));
  } catch (error) {
    yield put(getUserProficiencyLevelFailureAction(error?.response?.data ? error?.response?.data : 'Fetch failed'));
  }
}

export function* getScoreDetails({ payload }) {
  try {
    const response = yield api.get(`${URLs.GET_SCORE_DETAILS}?CurrentResponseId=${payload.crId}&AssessmentId=${payload.aId}`); //replace with SDA loginid
    yield put(getScoreDetailsSuccessAction(response.data.data));
  } catch (error) {
    yield put(getScoreDetailsFailureAction(error?.response?.data ? error?.response?.data : 'Fetch failed'));
  }
}

export function* getEvaluateScoreDetails({ payload }) {
  try {
 
    const response = yield api.get(`${URLs.GET_SCORE_DETAILS}?CurrentResponseId=${payload.crId}&AssessmentId=${payload.aId}`); //replace with SDA loginid
    yield put(getEvaluateScoreDetailsSuccessAction(response.data.data));
  } catch (error) {
    yield put(getEvaluateScoreDetailsFailureAction(error?.response?.data ? error?.response?.data : 'Fetch failed'));
  }
}

export function* getCurrentResponseData({ payload }) {
  try {
    const response = yield api.get(`${URLs.GET_CURRENT_RESPONSE_DATA}?CurrentResponseId=${payload.cId}`);
    yield put(getCurrentResponseDataSuccessAction(response.data.data));
  } catch (error) {
    yield put(getCurrentResponseDataFailureAction(error?.response?.data ? error?.response?.data : 'Fetch failed'));
  }
}

export function* saveResponseSaga({ payload }) {
  try {
    const body = typeof payload.data === 'string' ? JSON.parse(payload.data) : payload.data;
    const response = yield api.post(URLs.SAVE_RESPONSE, body);
    yield put(saveResponseSuccessAction({ data: response.data.data, type: payload.type }));

    if (payload.type === 'Saved' && body?.isAssessor && body?.currentResponseId) {
      yield put(getAssessorFeedbackAction({ crId: body.currentResponseId }));
    }
  } catch (error) {
    yield put(saveResponseFailureAction(error?.response?.data ? error?.response?.data : 'Fetch failed'));
  }
}
export function* getTakeSelfAssessmentSaga({ payload }) {
  try {
    const response = yield api.post(URLs.TAKE_SELF_ASSESSMENT, payload.data);
    yield put(getTakeSelfAssessmentSuccessAction({ data: normalizeTakeAssessmentPayload(response.data.data), type: payload.type }));
  } catch (error) {
    yield put(getTakeSelfAssessmentFailureAction(error?.response?.data ? error?.response?.data : 'Fetch failed'));
  }

}

export function* deleteAttachmentSaga({ payload }) {
  try {
    const response = yield api.post(URLs.DELETE_ATTACHMENT, payload);
    yield put(deleteAttachmentSuccessAction(response.data.data));
  } catch (error) {
    yield put(deleteAttachmentFailureAction(error?.response?.data ? error?.response?.data : 'Fetch failed'));
  }
}

export function* downloadAttachmentSaga({ payload }) {
  try {
    const response = yield api.get(
      `${URLs.DOWNLOAD_ATTACHMENT}?AssessmentCategoryQuestionsId=${payload.categoryId}&CurrentResponseId=${payload.responseId}`
    );
    yield put(downloadAttachmentSuccessAction(response.data.data));
  } catch (error) {
    yield put(downloadAttachmentFailureAction(error?.response?.data ? error?.response?.data : 'Fetch failed'));
  }
}

export function* resetExamSaga({ payload }) {
  try {
    const response = yield api.post(URLs.RESET_ASSESSMENT, payload);
    yield put(resetExamSuccessAction(response.data.data));
  } catch (error) {
    yield put(resetExamFailureAction(error?.response?.data ? error?.response?.data : 'Fetch failed'));
  }
}

export function* watchUserList() {
  console.log("watchlist")
  yield takeEvery(GET_USERLIST, getUserListSaga);
  yield takeEvery(GET_CYCLE, getCycleListSaga);
  yield takeEvery(GET_USER_ANALYSIS, getUserAnalysisSaga);
  yield takeEvery(GET_CURRENT_CYCLE_STATUS, getCurrentCycleStatus);
  yield takeEvery(GET_ASSESSOR_FEEDBACK, getAssessorFeedback);
  yield takeEvery(GET_USER_PROFICIENCYLEVEL, getUserProficiencyLevel);
  yield takeEvery(GET_SCORE_DETAILS, getScoreDetails);
  yield takeEvery(GET_CURRENT_RESPONSE_DATA, getCurrentResponseData);
  yield takeEvery(SAVE_RESPONSE, saveResponseSaga);
  yield takeEvery(DELETE_ATTACHMENT, deleteAttachmentSaga);
  yield takeEvery(DOWNLOAD_ATTACHMENT, downloadAttachmentSaga);
  yield takeEvery(RESET_ASSESSMENT, resetExamSaga);
  yield takeEvery(GET_SELF_CYCLE, getSelfCycleListSaga);
  yield takeEvery(TAKE_SELF_ASSESSMENT, getTakeSelfAssessmentSaga);
  yield takeEvery(GET_EVAL_CYCLE,getEvaluationCycleListSaga);
  yield takeEvery(GET_EVAL_SCORE_DETAILS, getEvaluateScoreDetails);
}

export default function* userListSaga() {
  yield all([watchUserList()]);
}
